export const AUTO_SUGGEST = `
  query autoSuggest($text: String!) {
    autoSuggest(text: $text) {
      status {
        ...StatusFragmentFields
      }
      data {
        contextMatch {
          ...ElasticMovieFragment
        }
        tags {
          ...ElasticTagsFragment
        }
        artists {
          ...ElasticArtistFragment
        }
      }
    }
  }
  fragment StatusFragmentFields on Status {
    message
    statusCode
    error
  }
  fragment ElasticMovieFragment on ElasticMovie {
    id
    uid
    title
    summary
    summaryEnglish
    descriptionEnglish
    description
    viewCount
    type
    playType
    tags
    categories
    genres
    landscapeImagePath
    portraitImagePath
    bannerImagePath
    createdAt
    productionYear
    typoGraphyImagePath
    isSolitary
    isExclusive
    score
    programTitle
    seasonTitle
  }
  fragment ElasticTagsFragment on ElasticTag {
    id
    name
    type
    landscapeImagePath
    portraitImagePath
    descriptor
    score
  }
  fragment ElasticArtistFragment on ElasticArtist {
    id
    fullName
    fullNameEnglish
    imagePath
    biography
    descriptor
    score
  }
`;

export const SEARCH = `
  query search($query: String!, $page: Int!) {
    search(query: $query, page: $page) {
      status {
        ...StatusFragmentFields
      }
      data {
        tags {
          ...ElasticTagsFragment
        }
        titleMatch {
          ...ElasticMovieFragment
        }
        contextMatch {
          ...ElasticMovieFragment
        }
        artists {
          ...ElasticArtistFragment
        }
      }
    }
  }
  fragment StatusFragmentFields on Status {
    message
    statusCode
    error
  }
  fragment ElasticTagsFragment on ElasticTag {
    id
    name
    type
    landscapeImagePath
    portraitImagePath
    descriptor
    score
  }
  fragment ElasticMovieFragment on ElasticMovie {
    id
    uid
    title
    summary
    summaryEnglish
    descriptionEnglish
    description
    viewCount
    type
    playType
    tags
    categories
    genres
    landscapeImagePath
    portraitImagePath
    bannerImagePath
    createdAt
    productionYear
    isSolitary
    isExclusive
    score
    programTitle
    seasonTitle
  }
  fragment ElasticArtistFragment on ElasticArtist {
    id
    fullName
    fullNameEnglish
    imagePath
    biography
    descriptor
    score
  }
`;

export const GET_TAGS = `
  query getTags($tagTypeID: String!, $page: Int!) {
    getTags(tagTypeID: $tagTypeID, page: $page) {
      status {
        statusCode
        message
      }
      data {
        id
        descriptor
        name
        landscapeImagePath
        portraitImagePath
      }
      pagination {
        currentPage
        totalPages
        totalRecords
      }
    }
  }
`;
